import React, { FC } from 'react';

import {
	formatSeverityText,
	getSeverityClass
} from 'src/common/components/severity-cell-formatter/SeverityCellFormatterHelper';

import './SeverityCellFormatter.scss';

interface ISeverityCellFormatterProps {
	severity: string;
}

export const SeverityCellFormatter: FC<ISeverityCellFormatterProps> = ({ severity }) => {
	if (!severity) {
		return null;
	}

	const severityClass = getSeverityClass(severity);
	const displayText = formatSeverityText(severity);

	return (
		<div className="severity-cell-formatter">
			<div className={`severity-indicator ${severityClass}`} aria-hidden="true" />
			<span className="severity-text">{displayText}</span>
		</div>
	);
};
